module.exports = __webpack_public_path__ + "assets/511ad430b8cb11fa7747dfeaf8b2a682.mp3";